var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPartWholeGrain(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 6,
    fill: "#DDF3FC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.1563 10.4487L17.0102 9.09778C17.6702 8.08936 17.7308 6.80017 17.1679 5.73254C16.6047 4.66382 15.5135 4 14.3198 4H9.68017C8.48654 4 7.39531 4.66382 6.83209 5.73242C6.26923 6.80017 6.32969 8.08936 6.98966 9.0979L7.84375 10.4487C6.66731 11.5958 6 13.1753 6 14.8438C6 16.8892 7.00397 18.7875 8.68558 19.9218L8.80168 20H15.1983L15.3144 19.9218C16.996 18.7875 18 16.8892 18 14.8438C18 13.1753 17.3327 11.5958 16.1563 10.4487V10.4487ZM14.7038 7.54126L13.7678 9.01892C13.1974 8.84033 12.6044 8.75 12 8.75C11.3956 8.75 10.8026 8.84033 10.2322 9.01892L9.30024 7.54761L9.29615 7.54126C9.16959 7.34851 9.21418 7.17273 9.27344 7.05981C9.33293 6.94702 9.4518 6.8125 9.68017 6.8125H14.3198C14.5482 6.8125 14.6671 6.94702 14.7262 7.05933C14.7858 7.17273 14.8304 7.34851 14.7038 7.54126V7.54126Z",
    fill: "#2DB3FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartWholeGrain);
export default __webpack_public_path__ + "static/media/part-whole-grain.40e9af0e.svg";
export { ForwardRef as ReactComponent };